var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6500_10908)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6500_10908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4614 22.3542C33.0572 31.9971 23.2905 37.8657 13.6465 35.461C4.00635 33.0568 -1.86221 23.2896 0.54304 13.6472C2.94604 4.00316 12.7127 -1.86597 22.354 0.538159C31.9975 2.94228 37.8655 12.7107 35.4614 22.3542Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9371 15.4352C26.2954 13.04 24.4718 11.7525 21.9782 10.8935L22.7871 7.64905L20.8122 7.15686L20.0247 10.3159C19.5055 10.1865 18.9722 10.0644 18.4423 9.94348L19.2355 6.76367L17.2617 6.27148L16.4522 9.51486C16.0225 9.41698 15.6006 9.32023 15.1911 9.21842L15.1933 9.2083L12.4697 8.52823L11.9443 10.6376C11.9443 10.6376 13.4097 10.9734 13.3787 10.9942C14.1786 11.1939 14.3232 11.7232 14.299 12.1429L13.3776 15.839C13.4327 15.8531 13.5042 15.8734 13.5829 15.9049C13.5171 15.8885 13.4468 15.8705 13.3742 15.8531L12.0827 21.0309C11.9848 21.2739 11.7368 21.6384 11.1777 21.5C11.1973 21.5287 9.74216 21.1417 9.74216 21.1417L8.76172 23.4024L11.3318 24.0431C11.8099 24.1629 12.2785 24.2884 12.7397 24.4065L11.9224 27.6881L13.8951 28.1803L14.7045 24.9335C15.2434 25.0798 15.7665 25.2148 16.2784 25.3419L15.4718 28.5735L17.4467 29.0657L18.264 25.7902C21.6317 26.4275 24.1641 26.1705 25.23 23.1245C26.089 20.672 25.1873 19.2574 23.4154 18.3349C24.7058 18.0373 25.6778 17.1885 25.9371 15.4352ZM21.4247 21.7627C20.8144 24.2152 16.6851 22.8894 15.3463 22.557L16.4308 18.2094C17.7696 18.5435 22.0626 19.205 21.4247 21.7627ZM22.0356 15.3997C21.4787 17.6306 18.0418 16.4972 16.927 16.2193L17.9102 12.2762C19.0251 12.554 22.6155 13.0727 22.0356 15.3997Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6500_10908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6500_10908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.a6623eead7fc958356c41552c5dfba7a.svg";
export { ForwardRef as ReactComponent };